// extracted by mini-css-extract-plugin
module.exports = {"Container":"labyrinth_Container__2s0u1","Row":"labyrinth_Row__1dyMr","Level":"labyrinth_Level__1sPos"};